import React from 'react';

import { ChipProps } from '@mui/material';

import { StyledNavChip } from './SessionNavChip.styles';

export const SessionNavChip = (props: ChipProps) => {
    return <StyledNavChip size="small" {...props} />;
};
